import { Component, OnInit, ViewChild, ElementRef, TemplateRef } from '@angular/core';
import { BaseService } from '../../base.service';
import { BankService } from '../../services/bank.service';
import { Router, ActivatedRoute } from '@angular/router';
import { BankListItem } from '../../models/bankListItem';
import { FormBuilder } from '@angular/forms';
import {Location} from '@angular/common';
import { environment } from '../../../environments/environment';
import { AngularFireStorage } from 'angularfire2/storage';
import { finalize } from 'rxjs/operators';
import { Env } from '../../env';
import { ToastrService } from 'ngx-toastr';
import { BsModalService, BsModalRef } from 'ngx-bootstrap';
import { Bank } from '../../models/bank';

@Component({
  selector: 'app-bank-detail',
  templateUrl: './bank-detail.component.html',
  styleUrls: [ ]
})
export class BankDetailComponent implements OnInit {
  @ViewChild('fileinput') fileinput: ElementRef;
  @ViewChild('templateConfirm') templateConfirm:TemplateRef<any>; 
  @ViewChild('templateError') templateError:TemplateRef<any>; 
  
  constructor(
    private baseService : BaseService ,
    private bankService : BankService,
    private router: Router,
    private location: Location,
    private route: ActivatedRoute,
    private fb: FormBuilder,
    private storage: AngularFireStorage, 
    private global: Env,
    private toastr: ToastrService,
    private modalService: BsModalService,
    ) { 
  }

  private bankForm = this.fb.group({
    name: [''],
    //status: ['']
  });
  
  titleComponent:string;
  titlePanel:string;
  bankId:number = 0;

  bank:Bank = {
    id : 0,
    logo : "/assets/ic_defalt.png",
    name : "",
    creationDate :  "",
    creationUserName : "",
    creationUserEmail : "",
    status : false,
    creationUser: {}
  }

  ngOnInit() {
    this.titleComponent = 'Detalle de Banco';
    this.titlePanel = 'Banco';
    this.baseService.changedComponentName(this.titleComponent);
    let id = this.route.snapshot.paramMap.get('id');
    this.get(parseInt(id));
    this.bankId = parseInt(id);
    console.log(this.bankId);
    //this.bankService.subirImagen();
  }
  
  get(id:number = 0){
    this.bankService.get(id).subscribe(r=>{
      console.log(r);
      this.bank = {
        id: r.id,
        logo: r.logo,
        name: r.name,
        status: r.status,
        creationDate: r.creationDate,
        creationUserName: r.creationUser.email,
        creationUserEmail: r.creationUser.email,
        creationUser: r.creationUser
      };
      //console.log();
      if ( this.bank.logo == "ic_default.png" ) {
        this.albumThumbURLs = "https://firebasestorage.googleapis.com/v0/b/gorent-1a46f.appspot.com/o/static%2Fic_default.png?alt=media";
      } else {
        this.albumThumbURLs = environment.URL_IMAGE_BASE+environment.URL_ENV_TARGET+`${this.global.FOLDER_IMAGES['Bank']}%2F`+this.bank.logo+environment.URL_IMAGE_SUFFIX;
      }
    })
  }
  /*
  fillData(): void {
    this.titlePanel = "Banco "+this.bank.name;
    console.log(this.bank);
    this.bankForm.setValue({
      name: this.bank.name,
      //status: (this.bank.status ? "true" : "false" )  
    });
    if ( this.bank.logo == "ic_default.png" ) {
      this.albumThumbURLs = "https://firebasestorage.googleapis.com/v0/b/gorent-1a46f.appspot.com/o/static%2Fic_default.png?alt=media";
    } else {
      this.albumThumbURLs = "";//environment.URL_IMAGE_BASE+environment.URL_ENV_TARGET+`${this.global.FOLDER_IMAGES.bank}%2F`+this.bank.logo+environment.URL_IMAGE_SUFFIX;
   }
   console.log(this.albumThumbURLs);
  }
  */

  albumThumbURLs:String = "";
  albumThumbFile: File = null;
  updateSinglePic($event){
    let files:FileList = $event.target  .files;
    let r = files[0];
    this.albumThumbFile = r;
    let reader = new FileReader(); 
    reader.readAsDataURL(r);
    reader.onload = (_event) => {
      let co = reader.result;
      //console.log(co);
      this.albumThumbURLs = <String>co; 
    }
    this.fileinput.nativeElement.value = "";
  }

  goBack(): void {
    this.location.back();
  }
  loadingMensaje:string = "";
  loadingRequest:boolean =  false;
  loading( status:boolean , men:string = "" ){
    this.loadingMensaje = men;
    this.loadingRequest = status;
  }
  onSubmit(){
    console.log(this.bankForm.value.name);
    // si albumThumbFile es null solo sube la data
    if (!this.albumThumbFile){
      this.loading(true, "Subiendo imagen...");
      this.bankService.updateBank( this.bank.logo , this.bankForm.value.name , this.bankId ).subscribe( r => {
        //poner mensaje de exito
        this.loading(false, "Subiendo imagen...");
        this.showSuccess("Información actualizada con éxito.");
        this.router.navigate(['/dashboard/banks']);
        //console.log('r',r);
      }, err => {
        this.loading(false, "Subiendo imagen...");
        this.showError("Hubo un error en el servidor");
      });
    // si albumThumbFile no es null solo sube la data y la foto
    } else {
      this.loading(true, "Actualizando...");
        let blobName = "bank-"+this.bankId;
        let extensionName = this.albumThumbFile.name.split('.').pop();
        let filePath = `${environment.env}/${this.global.FOLDER_IMAGES['Bank']}/${blobName}.${extensionName}`;
        let ref = this.storage.ref(filePath);
        
        
        let task = this.storage.upload(filePath, this.albumThumbFile );
        //ref.getDownloadURL( r => {console.log(r);} );
        task.snapshotChanges().pipe(
          finalize(() => {
            let downloadURL = ref.getDownloadURL()
            downloadURL.subscribe( url => { 
              console.log( url );
              this.albumThumbFile = null;
                this.bankService.updateBank( blobName+'.'+extensionName , this.bankForm.value.name , this.bankId ).subscribe( r => {
                  //poner mensaje de exito
                  //console.log('r',r);
                  this.loading(false, "Subiendo imagen...");
                  this.showSuccess("Información actualizada con éxito.");
                  this.router.navigate(['/dashboard/banks']);
                  this.get(this.bank.id);
                }, err => {
                  this.loading(false, "Subiendo imagen...");
                  this.showError("Hubo un error en el servidor");
                });
            });
          })
        ).subscribe();
    } 
  }

  showSuccess(message: string): any {
    this.toastr.success(message, 'Éxito!', {
      timeOut: 6000,
      positionClass: 'toast-top-right'
    });
  }

  showError(message: string): any {
    this.toastr.error(message, 'Error!', {
      timeOut: 6000,
      positionClass: 'toast-top-right'
    });
  }
  
  modalRef: BsModalRef;

  deleteBank(){
    this.modalRef = this.modalService.show(this.templateConfirm, {class: 'modal-sm'});
  }

  BankDeleteConfirm(){
    this.modalRef.hide();
    this.bankService.removeBank(this.bankId).subscribe( r => {
        const link = ['/dashboard/banks'];
        this.router.navigate(link);
    } , err => {
      this.modalService.show(this.templateError, {class: 'modal-sm'});
    });
  }

  BancDeleteDecline(){
    this.modalRef.hide();
  }
  
}



// WEBPACK FOOTER //
// D:/padriana/gorent-panel/src/app/dashboard/bank/bank-detail.component.ts